<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">A<span class="small">CKNOWLEDGEMENTS</span></p>
<p class="noindent">Thanks first to Melody Spurney, managing editor of <i>The Highlander</i>, whose encouragement and enthusiasm for my series of ghost stories (while a staff writer) got this whole thing rolling. Thanks also to Ran Shaffner, not only for his quintessential history of Highlands, but also for his immense dedication to archiving Highlands’s visual history through the photography collection of the Highlands Historical Society. Rhonda Gray Alexander at the Cashiers General Store was my Cashiers “connection” and provided me with a wealth of information and many contacts. And thanks most of all to my family and friends for their encouragement and patience throughout this project.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgement.vue?788899ba